<template>
  <el-dialog
    :title="$t('deleteMenuGroupCatalog.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog">
    <div align="center">
      <p>{{$t('deleteMenuGroupCatalog.confirmDeleteCatalogGroup')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{$t('deleteMenuGroupCatalog.wrongClick')}}</el-button>
      <el-button type="primary" @click="deleteMenuGroupCatalog">{{$t('deleteMenuGroupCatalog.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMenuGroupCatalog } from '@/api/dev/menuGroupCatalogApi'

export default {
  name: 'DeleteMenuGroupCatalog',
  data() {
    return {
      dialogVisible: false,
      deleteMenuGroupCatalogInfo: {}
    }
  },
  methods: {
    open(data) {
      this.deleteMenuGroupCatalogInfo = data
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteMenuGroupCatalogInfo = {}
    },
    async deleteMenuGroupCatalog() {
      try {
        const res = await deleteMenuGroupCatalog(this.deleteMenuGroupCatalogInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除菜单组目录失败:', error)
      }
    }
  }
}
</script>